import React from 'react';
import { connect } from 'react-redux';
import Routes from './routes';
import MesDemarches from './components/mesDemarches/MesDemarches';
import Ceaf from './ceaf';
import RouteSecurisee from '../../../components/RouteSecurisee/RouteSecurisee';
import CreerTitreDetention from './titre-detention/creer/CreerTitreDetention';
import VisualiserTitreDetention from './titre-detention/visualiser/VisualiserTitreDetention';
import {
    DROITS_AUTORISATION_ACQUISION_DETENTION,
    ROLE_METIER_ASSOCIATION_EMPLOYE,
} from '../../../utils/droitsEtRoles.constant';
import { getPath } from '../../../utils/router';

const MesDemarchesIndex = () => {
    return (
        <>
            <RouteSecurisee
                path={getPath(Routes.subroutes.titreDetetion.subroutes.creer)}
                render={(subProps) => <CreerTitreDetention {...subProps} />}
                exact
                droits={DROITS_AUTORISATION_ACQUISION_DETENTION}
            />

            <RouteSecurisee
                path={getPath(Routes.subroutes.titreDetetion.subroutes.visualiser)}
                render={(subProps) => <VisualiserTitreDetention {...subProps} />}
                exact
                droits={DROITS_AUTORISATION_ACQUISION_DETENTION}
            />

            <RouteSecurisee
                path={getPath(Routes.subroutes.ceaf)}
                render={(subProps) => <Ceaf {...subProps} />}
                droitsInterdits={[ROLE_METIER_ASSOCIATION_EMPLOYE]}
            />
            <RouteSecurisee
                path={getPath(Routes)}
                render={(subProps) => <MesDemarches {...subProps} />}
                exact
                droitsInterdits={[ROLE_METIER_ASSOCIATION_EMPLOYE]}
            />
        </>
    );
};

MesDemarchesIndex.propTypes = {};

export default connect()(MesDemarchesIndex);
